var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExpandFs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon ionic-ios-expand"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 37692",
    d: "M3.4 1.969h5.463A.975.975 0 009.84.992V.977A.975.975 0 008.863 0H.977A.975.975 0 000 .977v7.889a.975.975 0 00.977.977h.014a.975.975 0 00.977-.977V3.4l8.232 8.18a.967.967 0 00.689.281.946.946 0 00.689-.288.976.976 0 000-1.378z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 37693",
    d: "M26.023 0h-7.889a.975.975 0 00-.977.977v.014a.975.975 0 00.977.977H23.6L15.42 10.2a.978.978 0 001.38 1.387L25.031 3.4v5.463a.975.975 0 00.977.977h.014a.975.975 0 00.977-.977V.977A.975.975 0 0026.023 0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 37694",
    d: "M10.891 15.131a.967.967 0 00-.689.281L1.969 23.6v-5.466a.975.975 0 00-.977-.977H.977a.975.975 0 00-.977.977v7.889A.975.975 0 00.977 27h7.889a.975.975 0 00.977-.977v-.014a.975.975 0 00-.977-.977H3.4l8.18-8.232a.977.977 0 00-.689-1.666z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 37695",
    d: "M26.023 17.156h-.014a.975.975 0 00-.977.977V23.6L16.8 15.42a.967.967 0 00-.689-.281.946.946 0 00-.689.288.976.976 0 000 1.378l8.178 8.226h-5.466a.975.975 0 00-.977.977v.014a.975.975 0 00.977.977h7.889a.975.975 0 00.977-.977v-7.888a.975.975 0 00-.977-.978z"
  }))));
}

export default SvgExpandFs;